import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Modal, Button, message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";

import { projectsPath } from "../../helpers/paths";
import { PROJECTS_SIMPLIFIED_QUERY, DELETE_PROJECT_MUTATION } from "../../helpers/graphql/project";

const { confirm } = Modal;

interface ProjectFormInputValues {
  projectId: string;
}

export function DeleteProject({ projectId }: ProjectFormInputValues) {
  const navigate = useNavigate();

  const [deleteProject, { loading }] = useMutation(DELETE_PROJECT_MUTATION, {
    onCompleted: ({ deleteProject }) => {
      if (deleteProject) {
        message.success("Deleted project!");
        navigate(projectsPath());
      }
    },

    refetchQueries: () => [
      {
        query: PROJECTS_SIMPLIFIED_QUERY,
      },
    ],
  });

  const showDeleteConfirm = () => {
    confirm({
      title: "Are you sure you want to delete?",
      icon: <ExclamationCircleOutlined />,
      content: "All subgraphs, configuration and project data will be deleted.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteProject({ variables: { projectId: projectId } });
      },
    });
  };

  return (
    <Button
      type="ghost"
      style={{
        borderColor: "red",
        color: "red",
      }}
      icon={<DeleteOutlined />}
      onClick={showDeleteConfirm}
      loading={loading}
    >
      Delete Project
    </Button>
  );
}
